module.exports = __webpack_public_path__ + "img/douyin.6c34956c.png";